module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-600.c3d733f9.ttf";